import React from 'react';

import Fluid from '../../Fluid';
import RelatedArticles from '../RelatedArticles';
import { Section } from '../styles';

const RecommendedArticles = ({ relatedArticles, borderless = false, padding = 'none' }) => {
  return (
    <Section padding="md" borderless={borderless}>
      <Fluid padding={padding}>
        <RelatedArticles title="Recommended Articles" imgHeight="11rem" relatedArticles={relatedArticles} bottom />
      </Fluid>
    </Section>
  );
};

export default RecommendedArticles;
